module.exports = __webpack_public_path__ + "public/images/blue-arrow.0e317b5db42b070d826c4527f6536ad6.svg";